import $ from 'jQuery';


export default function() {

  $(function() {
    initialize_header();
  });


  function initialize_header() {
    const $sh = $('.site-header');
    const mobileBreakpoint = 1320;
    let viewportWidth = $(window).innerWidth();


    // ---
    // INITIALIZATION
    // ---
    initializeAria();
    keyboardListener();
    clickListener();
    focusListener();
    bind_submenu_toggles();
    bind_headerSmall_toggle();
    bind_headerLarge_searchToggle();
    bind_headerLarge_translateToggle();
    resizeListener();


    // ---
    // Initialize Aria
    // ---
    function initializeAria() {

      // Setup Aria-Controls for all submenu toggles
      // ---
      $('.menu__submenu', $sh).each(function(i, el) {
        const $submenu = $(el);
        const $toggle = $submenu.parent().find('.menu__submenu-toggle');
        let subID = 'submenu-' + i;

        $toggle.attr('aria-controls', subID);
        $submenu.attr('id', subID);
      });


      // Set Aria-Current
      // The nav link for the current page should be set to aria-current="page":
      // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-current
      // ---
      const $mainMenu = $('.menu--main .main-menu', $sh);
      const $menuLinks = $('.menu-item > a', $mainMenu);

      if ($menuLinks.length) {
        $menuLinks
          .filter('.is-active')
          .attr('aria-current', 'page');
      }
    }


    // ---
    // VIEWPORT ADAPTATION
    // ---
    function checkViewport() {
      viewportWidth = $(window).innerWidth();
      reset_headerSmall();
      reset_headerLarge();

      const $sTranslateContainer = $('.header-small__translate-container', $sh);
      const $lTranslateContainer = $('.header-large__translate-container', $sh);
      let $gtranslateBlock = $('.block--gtranslate', $sh);

      if (
        viewportWidth <= mobileBreakpoint
        && !($sTranslateContainer.find('.block--gtranslate')).length
      ) {
        $gtranslateBlock.appendTo($sTranslateContainer);
      }
      else if (
        viewportWidth > mobileBreakpoint
        && !($lTranslateContainer.find('.block--gtranslate')).length
      ) {
        $gtranslateBlock.appendTo($lTranslateContainer);
      }
    }


    // ---
    // SUB-MENU TOGGLES
    // ---
    function reset_submenus() {
      // collapse any open submenus, handy for ensuring resizes
      // run smoothly.
      const $mainMenu = $('.menu--main .main-menu', $sh);
      const $submenuToggles = $('.menu__submenu-toggle', $mainMenu);

      if ($submenuToggles.length) {
        $submenuToggles.each(function() {
          closeSubmenu($(this));
        });
      }
    }

    function bind_submenu_toggles() {
      const $mainMenu = $('.menu--main .main-menu', $sh);
      const $submenuToggles = $('.menu__submenu-toggle', $mainMenu);

      if ($submenuToggles.length) {

        $submenuToggles.off('click').on('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          const $thisToggle = $(this);

          if ($thisToggle.attr('aria-expanded') === 'true') {
            closeSubmenu($thisToggle);
          }
          else {
            // if any other submenus are currently open, close them.
            const $openSubMenuToggles = $submenuToggles.not($thisToggle).filter('[aria-expanded="true"]');

            $openSubMenuToggles.each(function() {
              closeSubmenu($(this));
            });

            openSubmenu($thisToggle);
          }
        });
      }
    }


    function openSubmenu($subMenuToggle) {
      const $parentItem = $subMenuToggle.closest('.menu-item');
      const $toggleLabelVerb = $subMenuToggle.find('.submenu__label-toggle-verb');
      const $subMenu = $parentItem.find('.menu__submenu').first();

      $toggleLabelVerb.html('Close');

      if (viewportWidth > mobileBreakpoint) {
        // desktop only
        $subMenu.show(0);

        // a very slight delay is required for the DOM to update
        // the `display` property first, so css transitions, and
        // aria updates will register for animation and AT.
        setTimeout(() => {
          $parentItem.addClass('-submenu-open');
          $subMenuToggle.attr('aria-expanded', 'true');
        }, 5);
      }
      else {
        // mobile only

        // Use jquery slide collapse to hide, this is still the most
        // reliable slide/expand option we have readily available.
        $subMenu.slideDown(250);
        $parentItem.addClass('-submenu-open');
        $subMenuToggle.attr('aria-expanded', 'true');
      }
    }


    function closeSubmenu($subMenuToggle) {
      const $parentItem = $subMenuToggle.closest('.menu-item');
      const $toggleLabelVerb = $subMenuToggle.find('.submenu__label-toggle-verb');
      const $subMenu = $parentItem.find('.menu__submenu').first();

      $parentItem.removeClass('-submenu-open')
      $subMenuToggle.attr('aria-expanded', 'false');
      $toggleLabelVerb.html('Menu');

      if (viewportWidth > mobileBreakpoint) {
        // desktop only

        // Give css transitions time to run before setting
        // the display property, hiding the element from
        // AT and tab-order simultaneously.
        setTimeout(() => {
          $subMenu.hide(0);
        }, 250);
      }
      else {
        // mobile only

        // Use jquery slide collapse to hide, this is still the most
        // reliable slide/expand option we have readily available.
        $subMenu.slideUp(250);
      }
    }


    // ---
    // KEYBOARD EVENTS FOR MAIN MENU
    // ---
    function keyboardListener() {
      const $body = $('body');
      const $headerSmall = $('.header-small', $body);
      const $headerLarge_searchForm = $('.header-large__search-form', $body);


      $(document).on('keydown', e => {

        // ESC key
        if (e.key === 'Escape') {

          // close any submenus that might be open.
          reset_submenus();

          // if any small header drawer is open, close them.
          if ($headerSmall.length && ($body.hasClass('-header-small__drawer--is-open') || $body.hasClass('-header-small__search-drawer--is-open'))) {
            close_headerSmall_drawer();
          }

          // if the large header search form is open, close it.
          if ($headerLarge_searchForm.length && $body.hasClass('-header-large__search-form--is-open')) {
            close_headerLarge_searchForm();
          }
        }
      });
    }


    // ---
    // Resize Listener
    // ---
    // On window resize (with debounce) update anything that might
    // change and need updating.
    function resizeListener() {
      let resizeTimeout;

      window.addEventListener('resize', () => {
        // If there's a timer, cancel it
        if (resizeTimeout) {
          window.cancelAnimationFrame(resizeTimeout);
        }

        // Setup the new requestAnimationFrame()
        // this asks the browser's rendering system to fit us
        // in when it has a microsecond moment breather.
        //
        // This is effectively a "debounce" timed so it will collide with
        // reflow and animation less.
        resizeTimeout = window.requestAnimationFrame(() => {
          checkViewport();
        });
      }, false);
    }


    // ---
    // Click Listener
    // ---
    // Detect click/activations and adapt.
    // Mainly for checking when expanded "dialogs" are open that
    // something else has been activated, so we should collapse.
    function clickListener() {
      const $body = $('body');
      const $headerSmall = $('.header-small', $body);
      const $headerLarge_search = $('.header-large__search', $body);
      const $headerLarge_searchForm = $('.header-large__search-form', $headerLarge_search);

      $(document).on('click', function(e) {
        // if any small header drawer is open:
        if ($headerSmall.length && ($body.hasClass('-header-small__drawer--is-open') || $body.hasClass('-header-small__search-drawer--is-open'))) {

          // close them if a click/activation is (somehow) detected outside of it.
          if (!$headerSmall.is(e.target) && !$headerSmall.has(e.target).length) {
            close_headerSmall_drawer();
          }
        }

        // if the large header search form is open:
        if ($headerLarge_searchForm.length && $body.hasClass('-header-large__search-form--is-open')) {

          // close it if a click/activation is detected outside of of the header search block
          if (!$headerLarge_search.is(e.target) && !$headerLarge_search.has(e.target).length) {
            close_headerLarge_searchForm();
          }
        }
      });
    }


    // ---
    // Focus Listener
    // ---
    // Detect when focus changes and adapt.
    // Mainly for trapping focus when drawers and dialogs are open.
    function focusListener() {
      const $body = $('body');
      const $headerSmall = $('.header-small', $body);
      const $headerSmall_logoLink = $('.block--branding__logo', $headerSmall);
      const $headerLarge_searchForm = $('.header-large__search-form', $body);

      document.addEventListener('focusin', function() {
        const $focusedElement = $(document.activeElement);

        // debug to find what's focused, good for catching focus traps.
        // console.log($focusedElement);

        // if any small header drawer is open:
        if ($headerSmall.length && ($body.hasClass('-header-small__drawer--is-open') || $body.hasClass('-header-small__search-drawer--is-open'))) {
          // capture tab focus inside of it, cycling within.
          if (!$focusedElement.closest('.header-small').length) {
            $headerSmall_logoLink.trigger('focus');
          }
        }

        // if the large header search form is open:
        if ($headerLarge_searchForm.length && $body.hasClass('-header-large__search-form--is-open')) {

          // close it if focus leaves the search block.
          if (!$focusedElement.closest('.header-large__search').length) {
            close_headerLarge_searchForm();
          }
        }
      }, true);
    }


    // ---
    // DESKTOP HEADER SEARCH TOGGLE
    // ---
    function bind_headerLarge_searchToggle() {
      const $body = $('body');
      const $headerLarge_searchToggle = $('.header-large__search-toggle', $body);

      if ($headerLarge_searchToggle.length) {
        $headerLarge_searchToggle.off('click').on('click', function() {

          if (viewportWidth > mobileBreakpoint) {
            // we only do any of this in desktop, just in case
            // the toggle somehow gets activated in desktop / via AT.

            if ($body.hasClass('-header-large__search-form--is-open')) {
              close_headerLarge_searchForm();
            }
            else {
              open_headerLarge_searchForm();
            }
          }
        });
      }
    }

    function open_headerLarge_searchForm() {
      const $body = $('body');
      const $headerLarge_searchToggle = $('.header-large__search-toggle', $body);

      // Check that we have a proper header rendered in the first place, just in case.
      if ($headerLarge_searchToggle.length) {
        const $headerLarge_searchToggleVerb = $('.search-toggle__label-toggle-verb', $headerLarge_searchToggle);
        const $headerLarge_searchForm = $('.header-large__search-form', $body);
        const $headerLarge_searchForm_input = $('.form-type-search .form-search', $headerLarge_searchForm);
        $headerLarge_searchToggle.attr('aria-expanded', 'true');
        $headerLarge_searchForm.show(0);
        $headerLarge_searchToggleVerb.html('Close');
        $headerLarge_searchForm_input.trigger('focus');


        // a very short delay before adding class to allow drawer's `display` property
        // to update, allowing the class-change to trigger css transitions.
        setTimeout(() => {
          $body.addClass('-header-large__search-form--is-open');
        }, 5);
      }
    }

    function close_headerLarge_searchForm() {
      const $body = $('body');
      const $headerLarge_searchToggle = $('.header-large__search-toggle', $body);

      // Check that we have a proper header rendered in the first place, just in case.
      if ($headerLarge_searchToggle.length) {
        const $headerLarge_searchToggleVerb = $('.search-toggle__label-toggle-verb', $headerLarge_searchToggle);
        const $headerLarge_searchForm = $('.header-large__search-form', $body);

        $body.removeClass('-header-large__search-form--is-open');
        $headerLarge_searchToggle.attr('aria-expanded', 'false');
        $headerLarge_searchToggleVerb.html('Open');
        $headerLarge_searchToggle.trigger('focus');

        // give enough time for the drawer slide away
        // animation to play before setting `display` to none.
        setTimeout(() => {
          $headerLarge_searchForm.hide(0);
        }, 255);
      }
    }


    // ---
    // DESKTOP HEADER TRANSLATE TOGGLE
    // ---
    function bind_headerLarge_translateToggle() {
      const $body = $('body');
      const $headerLarge_translateToggle = $('.header-large__translate-toggle, .header-large__translate__label', $body);

      if ($headerLarge_translateToggle.length) {

        $headerLarge_translateToggle.off('click').on('click', function() {

          if (viewportWidth > mobileBreakpoint) {
            // we only do any of this in desktop, just in case
            // the toggle somehow gets activated in desktop / via AT.

            if ($body.hasClass('-header-large__translate--is-open')) {
              close_headerLarge_translate();
            }
            else {
              open_headerLarge_translate();
            }
          }
        });
      }
    }

    function open_headerLarge_translate() {
      const $body = $('body');
      const $headerLarge_translateToggle = $('.header-large__translate-toggle', $body);

      // Check that we have a proper header rendered in the first place, just in case.
      if ($headerLarge_translateToggle.length) {
        const $headerLarge_translateToggleVerb = $('.translate-toggle__label-toggle-verb', $headerLarge_translateToggle);
        const $headerLarge_translateContainer = $('.header-large__translate-container', $body);
        const $headerLarge_translateSelect = $('#gtranslate_selector', $headerLarge_translateContainer);
        $headerLarge_translateToggle.attr('aria-expanded', 'true');
        $headerLarge_translateContainer.show(0);
        $headerLarge_translateToggleVerb.html('Close');
        $headerLarge_translateSelect.trigger('focus');


        // a very short delay before adding class to allow drawer's `display` property
        // to update, allowing the class-change to trigger css transitions.
        setTimeout(() => {
          $body.addClass('-header-large__translate--is-open');
        }, 5);
      }
    }

    function close_headerLarge_translate() {
      const $body = $('body');
      const $headerLarge_translateToggle = $('.header-large__translate-toggle', $body);

      // Check that we have a proper header rendered in the first place, just in case.
      if ($headerLarge_translateToggle.length) {
        const $headerLarge_translateToggleVerb = $('.translate-toggle__label-toggle-verb', $headerLarge_translateToggle);
        const $headerLarge_translateContainer = $('.header-large__translate-container', $body);

        $body.removeClass('-header-large__translate--is-open');
        $headerLarge_translateToggle.attr('aria-expanded', 'false');
        $headerLarge_translateToggleVerb.html('Open');
        $headerLarge_translateToggle.trigger('focus');

        // give enough time for the drawer slide away
        // animation to play before setting `display` to none.
        setTimeout(() => {
          $headerLarge_translateContainer.hide(0);
        }, 255);
      }
    }



    // ---
    // MOBILE MENU TOGGLE
    // ---
    function bind_headerSmall_toggle() {
      const $body = $('body');
      const $siteHeader_toggle = $('.site-header-toggle', $body);

      if ($siteHeader_toggle.length) {

        $siteHeader_toggle.off('click').on('click', function() {

          if (viewportWidth <= mobileBreakpoint) {
            // we only do any of this in mobile, just in case
            // the toggle somehow gets activated in desktop / via AT.

            if ($body.hasClass('-header-small__drawer--is-open')) {
              close_headerSmall_drawer();
            }
            else {
              open_headerSmall_drawer();
            }
          }
        });
      }
    }

    function open_headerSmall_drawer() {
      const $body = $('body');
      const $siteHeader_toggle = $('.site-header-toggle', $body);

      // Check that we have a proper header rendered in the first place, just in case.
      if ($siteHeader_toggle.length) {
        const $siteHeader_toggleVerb = $('.site-header-toggle__label-toggle-verb', $siteHeader_toggle);
        const $blockingLayer = $('.blocking-layer', $body);
        const $headerSmall_drawer = $('.header-small__drawer', $body);

        $blockingLayer.show(0);
        $headerSmall_drawer.show(0);
        $siteHeader_toggle.attr('aria-expanded', 'true');
        $siteHeader_toggleVerb.html('Close');

        // lock page scrolling.
        $body
          .css('height', '100%')
          .css('overflow', 'hidden');

        // a very short delay before adding class to allow drawer's `display` property
        // to update, allowing the class-change to trigger css transitions.
        setTimeout(() => {
          $body.addClass('-header-small__drawer--is-open');
        }, 5);
      }
    }

    function close_headerSmall_drawer() {
      const $body = $('body');
      const $siteHeader_toggle = $('.site-header-toggle', $body);

      // Check that we have a proper header rendered in the first place, just in case.
      if ($siteHeader_toggle.length) {
        const $siteHeader_toggleVerb = $('.site-header-toggle__label-toggle-verb', $siteHeader_toggle);
        const $blockingLayer = $('.blocking-layer', $body);
        const $headerSmall_drawer = $('.header-small__drawer', $body);

        $blockingLayer.css('opacity', '0');
        $blockingLayer.hide(0);
        $body.removeClass('-header-small__drawer--is-open');
        $siteHeader_toggle.attr('aria-expanded', 'false');
        $siteHeader_toggleVerb.html('Menu');

        // reset page natural scrolling.
        $body
          .css('height', 'inherit')
          .css('overflow', 'inherit');

        // give enough time for the drawer slide away
        // animation to play before setting `display` to none.
        setTimeout(() => {
          $headerSmall_drawer.hide(0);
        }, 255);
      }
    }


    function reset_headerSmall() {
      // this also closes the small search drawer, if open.
      close_headerSmall_drawer();
      reset_submenus();
    }


    function reset_headerLarge() {
      close_headerLarge_searchForm();
      reset_submenus();
    }
  }
}
